import { render, staticRenderFns } from "./NewTgr.vue?vue&type=template&id=66613eae&scoped=true&"
import script from "./NewTgr.vue?vue&type=script&lang=ts&"
export * from "./NewTgr.vue?vue&type=script&lang=ts&"
import style0 from "./NewTgr.vue?vue&type=style&index=0&id=66613eae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66613eae",
  null
  
)

export default component.exports